class Authorize {
    constructor() {

    }

    getChannelId() {
        return this.channelId;
    }

    setChannelId(channelId) {
        this.channelId = channelId;
    }
}

let authorize = new Authorize();

export default authorize;